import {Pipe, PipeTransform} from '@angular/core';
import {RefData} from '../../../_models/ref.data.model';

@Pipe({
  name: 'programInfo'
})
export class ProgramInfoPipe implements PipeTransform {

  transform(programName: string, refData: RefData): string {
    if (refData && refData.programs) {
      return refData.programs.find(item => item.name === programName).description;
    }
    return '';
  }
}
